export default __webpack_public_path__ + "static/media/sign-up-ai.fd87e18c.svg";